import { getUserRegion } from '../../../../../utils';
import Region from '../../../../constants/region';
import config from './dummy-config';

const configuredNavigation = {
    BONGARDS: config.bongardsConfig,
    CACIQUE: config.caciqueConfig,
    CDI: config.cdiConfig,
    DEFAULT: config.defaultConfig,
    LEGACY: config.legacyConfig,
    MMPA: config.mmpaConfig,
    NL: config.nlConfig,
    PRAIRIE: config.prairieConfig,
    [Region.TCJ.NEBRASKA]: config.tcjConfig,
    [Region.TCJ.LIBERTY]: config.tcjConfig,
    [Region.TCJ.WHITEEAGLE]: config.tcjV2Config,
    [Region.TCJ.ERIE]: config.tcjV2Config,
    [Region.TCJ.KYTN]: config.tcjConfig,
    [Region.TCJ.GPDA]: config.tcjV2Config,
    UDA: config.udaConfig,
    UNC: config.uncConfig,
    [Region.US_DEMO]: config.usDemoConfig,
    [Region.CA_DEMO]: config.usDemoConfig,
    [Region.DEMO]: config.usDemoConfig,
    [Region.PSC]: config.pscConfig,
    [Region.IMP]: config.impConfig,
};

export default configuredNavigation;

export const getNavigationConfig = () => {
    const region = getUserRegion();
    return Object.values(configuredNavigation[region] ?? configuredNavigation.DEFAULT);
};
